import { createContentPropTypes } from '../../../helpers/content';

const pageContent = {
	toLabel: 'To',
	fromLabel: 'From',
	amountLabel: 'Amount',
	referenceLabel: 'Reference',
	dateLabel: 'Date',
	totalAmountLabel: 'Total',
	title: 'Your imported payment details',
	description: [
		'Please check the imported entries are correct before you continue.',
		'We’ll check for any problems with account details before we make the payments.',
	],
	paymentNamePopperText:
		'Easily identify this group of payments with a unique name (such as ‘Week 24 wages’ or ‘May invoices’). This is the name that’ll appear on your payment history and when authorisation is required.',
	batchPaymentNameLabel: 'Payment name',
	batchPaymentNameLabelSubText: 'You can give this payment a unique name',
	continueButtonText: 'Continue',
	paymentNameRequirements: 'Maximum 18 characters',
	tableHeader: [
		{ type: 'account', label: 'From' },
		{ type: 'account', label: 'To' },
		{ type: 'currency', label: 'Amount' },
		{ type: 'iban', label: 'Reference' },
		{ type: 'date', label: 'Date' },
	],
	maxLimitExceededMessage: 'This exceeds the maximum amount of money you can move online per transaction.',
};

export const contentPropTypes = createContentPropTypes(pageContent);

export default pageContent;
